import { invitationsEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import type { ValidateInvitationResponseType } from "@/types";

interface ApiValidateInvitationResponseInterface {
    data?: { email?: string },
    email?: string,
}

export const validateInvitationHandler = async (token: string): Promise<ValidateInvitationResponseType> => {
    try {
        const response = await axiosClient.get<ApiValidateInvitationResponseInterface>(invitationsEndpoints.validate(token));

        const email = response.data.data?.email ?? response.data.email ?? "";

        return {
            email,
            isValid: true,
        };
    } catch {
        return {
            email: "",
            isValid: false,
        };
    }
};
